import { IDeleteAssistenciaTecnicaUseCase } from "../../../presentation/useCases/delete/delete_assistencia_tecnica_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteAssistenciaTecnicaUseCase
 */

export class DeleteAssistenciaTecnicaUseCase implements IDeleteAssistenciaTecnicaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteAssistenciaTecnica(
    idAssistenciaTecnica: number,
  ): Promise<void> {
    await this.repository.deleteAssistenciaTecnica(
      idAssistenciaTecnica,
    );
  }
}
